var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name === 'azat')?_c('AzatLinksPage'):(_vm.name === 'soft')?_c('SimdelSoftLinksPage'):(_vm.name === 'links')?_c('SimDeliveryLinksPage'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }